import React from 'react';
import PropTypes from 'prop-types';

const HousingIntakeForm = ({ data, signatureData,currentDate }) => {
  // Styles object for consistent styling
  const styles = {
    container: {
      fontFamily: "Arial",
      padding: "20px",
      maxWidth: "800px",
      margin: "0 auto",
      lineHeight: "1.2",
      fontSize: "18px",
      height: "2430px",
    },
    pageBreak: {
      marginBottom: "40px",
      pageBreakBefore: "always"
    },
    sectionTitle: {
      fontWeight: "bold",
      fontSize: "27px",
      marginBottom: "15px",
      paddingBottom: "5px",
      borderBottom: "1px solid #ddd",
      alignItems: "center",
      display: "flex",
      justifyContent: "center"
    },
    formRow: {
      display: "flex",
      marginBottom: "15px",
      alignItems: "center"
    },
    formLabel: {
      width: "200px",
      fontWeight: "bold",
      flexShrink: 0
    },
    formLabels: {
      width: "500px",
      fontWeight: "bold",
      flexShrink: 0
    },
    formField: {
      flexGrow: 1,
      borderBottom: "1px solid #ccc",
      minHeight: "20px"
    },
    formFieldLarge: {
      borderBottom: "1px solid #ccc",
      marginBottom: "15px",
      minHeight: "20px"
    },
    checkboxContainer: {
      display: "inline-flex",
      alignItems: "center",
      marginRight: "20px"
    },
    tableHeader: {
      display: "flex",
      fontWeight: "bold",
      marginBottom: "10px",
      borderBottom: "1px solid #000",
      paddingBottom: "5px"
    },
    tableRow: {
      display: "flex",
      marginBottom: "10px"
    },
    tableCell: {
      padding: "5px 0",
      borderBottom: "1px solid #eee"
    },
    signatureContainer: {
      marginTop: "40px",
      marginBottom: "20px"
    },
    signatureLine: {
      height: "30px",
      borderBottom: "1px solid #000",
      marginBottom: "5px"
    },
    signatureLabel: {
      fontSize: "12px",
      color: "#666"
    },
    checkbox: {
      display: "inline-block",
      width: "14px",
      height: "14px",
      border: "1px solid #000",
      marginRight: "5px",
      position: "relative",
      verticalAlign: "middle"
    },
    checkboxMark: {
      position: "absolute",
      backgroundColor: "#000",
      top: "6px",
      left: "2px",
      transform: "rotate(45deg)",
      width: "10px",
      height: "2px"
    },
    checkboxMark2: {
      position: "absolute",
      backgroundColor: "#000",
      top: "5px",
      left: "4px",
      transform: "rotate(-45deg)",
      width: "6px",
      height: "2px"
    }
  };

  // Checkbox component with improved styling
  const Checkbox = ({ checked, style }) => (
    <span style={{ ...styles.checkbox, ...style }}>
      {checked && (
        <>
          <span style={styles.checkboxMark}></span>
          <span style={styles.checkboxMark2}></span>
        </>
      )}
    </span>
  );

  // Extract data from the provided structure
  const personalContact = data.personalContact || {};
  const medicalLegal = data.medicalLegal || {};
  const residencySponsor = data.residencySponsor || {};
  const emergencyContact = personalContact.emergencyContact || {};

  return (
    <div style={styles.container}>
      {/* Page 1 */}
      <div style={{ marginBottom: '40px' }}>
        {/* Personal Information Section */}
        <div style={styles.formRow}>
          <div style={styles.formLabel}>Name:</div>
          <div style={styles.formField}>{`${personalContact.firstName || ""} ${personalContact.lastName || ""}`}</div>
        </div>
        
        <div style={styles.formRow}>
          <div style={styles.formLabel}>DOB:</div>
          <div style={{ ...styles.formField, width: '100px' }}>{personalContact.dob || ""}</div>
          <div style={{ ...styles.formLabel, width: '80px', marginLeft: '40px' }}>Phone #:</div>
          <div style={styles.formField}>{personalContact.phone || ""}</div>
        </div>
        
        <div style={styles.formRow}>
          <div style={styles.formLabel}>Home address:</div>
          <div style={styles.formField}>{`${personalContact.address || ""}, ${personalContact.city || ""}, ${personalContact.state || ""} ${personalContact.zip || ""}`}</div>
        </div>
        
        <div style={styles.formRow}>
          <div style={styles.formLabel}>Last 4 # of Social Security #:</div>
          <div style={{ ...styles.formField, width: '50px' }}>{personalContact.ssnLast4 || ""}</div>
          <div style={{ ...styles.formLabel, width: '100px', marginLeft: '40px' }}>Sobriety Date:</div>
          <div style={{ ...styles.formField, width: '100px' }}>{medicalLegal.sobrietyDate || ""}</div>
        </div>
        
        {/* Contact Information */}
        <div style={styles.formRow}>
          <div style={styles.formLabel}>Emergency Contact:</div>
          <div style={styles.formField}>{`${emergencyContact.name || ""} (${emergencyContact.relationship || ""})`}</div>
        </div>
        
        <div style={styles.formRow}>
          <div style={styles.formLabel}>Emergency Contact Phone:</div>
          <div style={styles.formField}>{emergencyContact.phone || ""}</div>
        </div>
        
        {/* Rehab Facility Information */}
        <div style={{ ...styles.formRow, marginBottom: '30px' }}>
          <div style={styles.formLabel}>Currently residing in rehab facility:</div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={residencySponsor.inFacility === false} />
            <span>No</span>
          </div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={residencySponsor.inFacility === true} />
            <span>Yes</span>
          </div>
        </div>
        
        {residencySponsor.inFacility && (
          <>
            <div style={styles.formRow}>
              <div style={styles.formLabel}>Facility Name:</div>
              <div style={styles.formField}>{residencySponsor.facilityName || ""}</div>
            </div>
            
            <div style={styles.formRow}>
              <div style={styles.formLabel}>Entry Date:</div>
              <div style={{ ...styles.formField, width: '100px' }}>{residencySponsor.entryDate || ""}</div>
              <div style={{ ...styles.formLabel, width: '100px', marginLeft: '40px' }}>Discharge date:</div>
              <div style={{ ...styles.formField, width: '100px' }}>{residencySponsor.dischargeDate || ""}</div>
            </div>
          </>
        )}
        
        {/* Emergency Contacts Table */}
        <h2 style={styles.sectionTitle}>Emergency Contact(s)</h2>
        <div style={styles.tableHeader}>
          <div style={{ width: '150px' }}>RELATIONSHIP</div>
          <div style={{ width: '200px' }}>NAME</div>
          <div style={{ width: '200px' }}>PHONE NUMBER(S)</div>
        </div>
        
        <div style={styles.tableRow}>
          <div style={{ ...styles.tableCell, width: '150px' }}>{emergencyContact.relationship || ""}</div>
          <div style={{ ...styles.tableCell, width: '200px' }}>{emergencyContact.name || ""}</div>
          <div style={{ ...styles.tableCell, width: '200px' }}>{emergencyContact.phone || ""}</div>
        </div>
      </div>
      
      {/* Page 2 */}
      <div style={styles.pageBreak}>
        {/* Housing History Section */}
        <h2 style={styles.sectionTitle}>Housing History</h2>
        
        <h3 style={{ ...styles.sectionTitle, fontSize: '13px' }}>Substance Abuse Housing History</h3>
        
        {/* Housing History Table Header */}
        <div style={styles.tableHeader}>
          <div style={{ width: '200px' }}>Location</div>
          <div style={{ width: '200px' }}>Date Range</div>
          <div style={{ width: '150px' }}>Length of Stay</div>
          <div style={{ width: '150px' }}>Responsible Party</div>
        </div>
        
        {residencySponsor.residences && residencySponsor.residences.map((residence, i) => (
          <div key={i} style={styles.tableRow}>
            <div style={{ ...styles.tableCell, width: '200px' }}>{residence.location || ""}</div>
            <div style={{ ...styles.tableCell, width: '200px' }}>{residence.dateRange || ""}</div>
            <div style={{ ...styles.tableCell, width: '150px' }}>{residence.length || ""}</div>
            <div style={{ ...styles.tableCell, width: '150px' }}>{residence.responsibleParty || ""}</div>
          </div>
        ))}
        
        {/* Medical Section */}
        <h2 style={styles.sectionTitle}>Medical</h2>
        
        <div style={{ ...styles.formRow, marginBottom: '15px' }}>
          <div style={styles.formLabels}>Are you compliant with all your medication(s)</div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={medicalLegal.medicationCompliance === "Compliant"} />
            <span>Compliant</span>
          </div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={medicalLegal.medicationCompliance !== "Compliant"} />
            <span>Not Compliant</span>
          </div>
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <div style={styles.formLabels}>Mental Health Diagnosis (Past or Present)</div>
          <div style={styles.formFieldLarge}>
            {medicalLegal.mentalHealthCondition ? medicalLegal.mentalHealthDetails : "None"}
          </div>
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <div style={styles.formLabels}>Legal Issues (Past or Present)</div>
          <div style={styles.formFieldLarge}>
            {medicalLegal.legalCases ? medicalLegal.legalCasesDetails : "None"}
          </div>
        </div>
        
        <div style={styles.formRow}>
          <div style={styles.formLabels}>Psychiatric conditions / diagnosis:</div>
          <div style={{ ...styles.formField, width: '200px' }}>{medicalLegal.mentalHealthDetails || "None"}</div>
          <div style={{ ...styles.formLabels, width: '120px', marginLeft: '20px' }}>Physical Limitations:</div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={medicalLegal.physicalLimitations === false} />
            <span>No</span>
          </div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={medicalLegal.physicalLimitations === true} />
            <span>Yes</span>
          </div>
        </div>
        
        {medicalLegal.physicalLimitations && (
          <div style={{ marginBottom: '15px' }}>
            <div style={styles.formLabel}>If yes Explain:</div>
            <div style={styles.formFieldLarge}>{medicalLegal.physicalLimitationsDetails || ""}</div>
          </div>
        )}
        
        {/* Physical Abilities Section */}
        <h3 style={{ ...styles.sectionTitle, fontSize: '13px' }}>Personal Status</h3>
        
        <div style={{ display: 'flex', flexWrap: 'wrap', marginBottom: '30px' }}>
          <div style={{ width: '50%', marginBottom: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ width: '120px' }}>Marital Status:</span>
              <span>{personalContact.maritalStatus || ""}</span>
            </div>
          </div>
          
          <div style={{ width: '50%', marginBottom: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ width: '120px' }}>Has Children:</span>
              <div style={styles.checkboxContainer}>
                <Checkbox checked={personalContact.hasChildren === false} />
                <span>No</span>
              </div>
              <div style={styles.checkboxContainer}>
                <Checkbox checked={personalContact.hasChildren === true} />
                <span>Yes</span>
              </div>
            </div>
          </div>
          
          <div style={{ width: '50%', marginBottom: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ width: '120px' }}>Employed:</span>
              <div style={styles.checkboxContainer}>
                <Checkbox checked={personalContact.isEmployed === false} />
                <span>No</span>
              </div>
              <div style={styles.checkboxContainer}>
                <Checkbox checked={personalContact.isEmployed === true} />
                <span>Yes</span>
              </div>
            </div>
          </div>
          
          <div style={{ width: '50%', marginBottom: '10px' }}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ width: '120px' }}>Has Vehicle:</span>
              <div style={styles.checkboxContainer}>
                <Checkbox checked={personalContact.hasVehicle === false} />
                <span>No</span>
              </div>
              <div style={styles.checkboxContainer}>
                <Checkbox checked={personalContact.hasVehicle === true} />
                <span>Yes</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      {/* Page 3 */}
      <div>
        {/* Sponsor Information */}
        <h2 style={styles.sectionTitle}>Sponsor Information</h2>
        
        <div style={styles.formRow}>
          <div style={styles.formLabel}>Name:</div>
          <div style={styles.formField}>{residencySponsor.sponsorName || ""}</div>
        </div>
        
        <div style={styles.formRow}>
          <div style={styles.formLabel}>Phone Number:</div>
          <div style={styles.formField}>{residencySponsor.sponsorPhone || ""}</div>
        </div>
        
        <div style={styles.formRow}>
          <div style={styles.formLabel}>Relationship:</div>
          <div style={styles.formField}>{residencySponsor.sponsorRelationship || ""}</div>
        </div>
        
        <div style={{ ...styles.formRow, marginBottom: '30px' }}>
          <div style={styles.formLabel}>Has Permission:</div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={residencySponsor.hasPermission === false} />
            <span>No</span>
          </div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={residencySponsor.hasPermission === true} />
            <span>Yes</span>
          </div>
        </div>
        
        <div style={{ ...styles.formRow, marginBottom: '30px' }}>
          <div style={styles.formLabels}>Convicted sex offender/predator:</div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={residencySponsor.sexOffense === false} />
            <span>No</span>
          </div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={residencySponsor.sexOffense === true} />
            <span>Yes</span>
          </div>
          
          <div style={{ ...styles.formLabel, width: '100px', marginLeft: '20px' }}>Convicted felon?</div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={residencySponsor.felonyConviction === false} />
            <span>No</span>
          </div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={residencySponsor.felonyConviction === true} />
            <span>Yes</span>
          </div>
        </div>
        
        {/* Belongings Section */}
        <h2 style={styles.sectionTitle}>Belongings & Devices</h2>
        
        <div style={{ ...styles.formRow, marginBottom: '15px' }}>
          <div style={styles.formLabel}>Items to be stored:</div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={data.belongingsDevices?.hasItemsToStore === true} />
            <span>Yes</span>
          </div>
          <div style={styles.checkboxContainer}>
            <Checkbox checked={data.belongingsDevices?.hasItemsToStore === false} />
            <span>No</span>
          </div>
        </div>
        
        {data.belongingsDevices?.hasItemsToStore && (
          <div style={{ marginBottom: '15px' }}>
            <div style={styles.formLabel}>Stored Items:</div>
            <div style={styles.formFieldLarge}>
              {Object.entries(data.belongingsDevices?.storedItems || {})
                .filter(([key, value]) => value && key !== "otherDetails")
                .map(([key]) => key.replace(/([A-Z])/g, ' $1').trim())
                .join(", ")}
              {data.belongingsDevices?.storedItems?.other && `, ${data.belongingsDevices.storedItems.otherDetails}`}
            </div>
          </div>
        )}
        
        <div style={{ marginBottom: '15px' }}>
          <div style={styles.formLabel}>Restricted Items:</div>
          <div style={styles.formFieldLarge}>
            {data.belongingsDevices?.hasRestrictedItems ? 
              data.belongingsDevices.restrictedItemsList : "None"}
          </div>
        </div>
        
        <div style={{ marginBottom: '15px' }}>
          <div style={styles.formLabel}>Special Instructions:</div>
          <div style={styles.formFieldLarge}>
            {data.belongingsDevices?.specialInstructions || "None"}
          </div>
        </div>
        
        {/* Signature Section */}
        <div style={styles.signatureContainer}>
        <div style={{ marginBottom: "30px" }}>
            <img
              src={signatureData || ""}
              alt="Client Signature"
              style={{
                width: "200px",
                height: "70px",
                borderBottom: "1px solid black",
              }}
            />
            <p>
              <span>Resident Signature:</span>
            </p>
          </div>
          <div style={{ marginBottom: "20px" }}>
          {!currentDate && (
            <div
              style={{
                borderBottom: "1px solid black",
                width: "100px",
                height: "30px",
              }}
            ></div>
          )}
          <p>Date: {currentDate}</p>
        </div>
        </div>
      </div>
    </div>
  );
};

HousingIntakeForm.propTypes = {
  data: PropTypes.shape({
    personalContact: PropTypes.shape({
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      dob: PropTypes.string,
      phone: PropTypes.string,
      address: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string,
      ssnLast4: PropTypes.string,
      emergencyContact: PropTypes.shape({
        name: PropTypes.string,
        relationship: PropTypes.string,
        phone: PropTypes.string,
        email: PropTypes.string
      }),
      maritalStatus: PropTypes.string,
      hasChildren: PropTypes.bool,
      isEmployed: PropTypes.bool,
      hasVehicle: PropTypes.bool
    }),
    medicalLegal: PropTypes.shape({
      sobrietyDate: PropTypes.string,
      mentalHealthCondition: PropTypes.bool,
      mentalHealthDetails: PropTypes.string,
      medications: PropTypes.bool,
      medicationCompliance: PropTypes.string,
      physicalLimitations: PropTypes.bool,
      physicalLimitationsDetails: PropTypes.string,
      legalCases: PropTypes.bool,
      legalCasesDetails: PropTypes.string
    }),
    residencySponsor: PropTypes.shape({
      inFacility: PropTypes.bool,
      facilityName: PropTypes.string,
      entryDate: PropTypes.string,
      dischargeDate: PropTypes.string,
      residences: PropTypes.arrayOf(PropTypes.shape({
        location: PropTypes.string,
        dateRange: PropTypes.string,
        length: PropTypes.string,
        responsibleParty: PropTypes.string
      })),
      sponsorName: PropTypes.string,
      sponsorPhone: PropTypes.string,
      sponsorRelationship: PropTypes.string,
      hasPermission: PropTypes.bool,
      felonyConviction: PropTypes.bool,
      sexOffense: PropTypes.bool,
      onProbation: PropTypes.bool
    }),
    belongingsDevices: PropTypes.shape({
      hasItemsToStore: PropTypes.bool,
      storedItems: PropTypes.object,
      hasRestrictedItems: PropTypes.bool,
      restrictedItemsList: PropTypes.string,
      specialInstructions: PropTypes.string
    })
  }).isRequired,
  signatureData: PropTypes.string
};

export default HousingIntakeForm;